import { Form, Formik } from "formik";
import { Button } from "@jsq/ds/core";
import { AddRoleModal } from "../../../UsersTable/components/AddRoleModal";
import { useAddRoleForm } from "./hooks";
import { schema } from "./schema";

export const AddRole = ({ userIds }: { userIds: string[] }) => {
  const filteredUserIds = userIds.filter(Boolean);
  const { initialValues, onHide, openModal, showModal, addCanopyRole } = useAddRoleForm({
    userIds: filteredUserIds,
  });

  return (
    <Formik initialValues={initialValues} onSubmit={addCanopyRole} validationSchema={schema}>
      {({ handleSubmit, isSubmitting, resetForm }) => {
        const handleClose = () => {
          resetForm();
          onHide();
        };

        return (
          <Form>
            <Button icon="plus" variant="neutral" onClick={openModal}>
              Add role
            </Button>
            <AddRoleModal
              showModal={showModal}
              onHide={handleClose}
              isSubmitting={isSubmitting}
              handleSubmit={handleSubmit}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
